export default function AnswerImage({
    draggable,
    onDragOver,
    onDrop,
    left,
    top,
    background,
    onDragStart,
    onDragEnd,
    onTouchStart,
    onTouchMove,
    onTouchEnd,
    src,
    width,
    height,
    zIndex,
}) {
    return (
        <div
            className="type5-answerImageBg "
            onDragOver={onDragOver}
            onDrop={onDrop}
            style={{
                width: width,
                height: height,
                background: 'transparent ',
            }}>
            <div
                className="type5-answerField"
                onTouchStart={onTouchStart}
                onTouchMove={onTouchMove}
                onTouchEnd={onTouchEnd}
                onDragStart={onDragStart}
                onDragEnd={onDragEnd}
                draggable={draggable}
                style={{
                    position: 'absolute',
                    zIndex,
                    left: left,
                    top,
                    width,
                    height,
                }}>
                <div className="type5-answer">
                    <img
                        style={{
                            width: width,
                            height: height,
                        }}
                        src={src}
                        alt="image"
                    />
                </div>
            </div>
        </div>
    );
}
